import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
    getAdvancedSettings,
    updateAdvancedSettings,

} from "../../../actions/adminConsole";
import { Header, Grid, Radio, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import ActiveDaysSelector from "../ActiveDays/ActiveDays";
import isEqual from 'lodash/isEqual';
import { Loader } from "semantic-ui-react";
import { useEffect } from "react";


export const AdvancedSettings = ({
    updateAdvancedSettings,
    advancedSettings,
}) => {

    const { t } = useTranslation();
    const [maximizeGreenZone, setMaximizeGreenZone] = useState(Object.keys(advancedSettings).length === 0 ? false : advancedSettings.advancedSettings.advanced_settings.maximize_green_zone)
    const [extendSimTimeFrame, setExtendSimTimeFrame] = useState(Object.keys(advancedSettings).length === 0 ? false : advancedSettings.advancedSettings.advanced_settings.extend_simulation_time_frame)
    const [activeDays, setActiveDays] = useState(Object.keys(advancedSettings).length === 0 ? {} : advancedSettings.advancedSettings.active_days)
    

    useEffect(() => {
        if (Object.keys(advancedSettings).length !== 0) {
            setMaximizeGreenZone(advancedSettings.advancedSettings.advanced_settings.maximize_green_zone)
            setExtendSimTimeFrame(advancedSettings.advancedSettings.advanced_settings.extend_simulation_time_frame)
            setActiveDays(advancedSettings.advancedSettings.active_days)
        }
    },[advancedSettings])

    const submitAdvancedSettigs = () => {
        updateAdvancedSettings(
            { 
                advanced_settings: {
                    maximize_green_zone: maximizeGreenZone, 
                    extend_simulation_time_frame: extendSimTimeFrame,
                }, 
                active_days: activeDays
            })
    }
    const isAdvancedSettingsModified = () => {
        const maximizeGreenZoneUpdate = Object.keys(advancedSettings).length === 0 ? false : maximizeGreenZone !== advancedSettings.advancedSettings.maximize_green_zone
        const extendSimTimeFrameUpdate = Object.keys(advancedSettings).length === 0 ? false : extendSimTimeFrame !== advancedSettings.advancedSettings.extend_simulation_time_frame
        const activeDaysUpdate = Object.keys(advancedSettings).length === 0 ? false : !isEqual(activeDays, advancedSettings.advancedSettings.active_days)
        return (maximizeGreenZoneUpdate || extendSimTimeFrameUpdate || activeDaysUpdate)
    }


    if (Object.keys(advancedSettings).length === 0) 
        return(
            <Loader active size="large" />
        )
    
    return (
            <Grid padded={"horizontally"}>
                
                <Grid.Row>
            <Header className="create-workspace-header">{t("account.adminConsole.advancedSettings")}</Header>
            </Grid.Row>

            <Grid.Row columns={2}>
                    <Grid.Column textAlign="left" width={3}>
                    <label >{t("account.adminConsole.maximizeGreenZone")}</label>
                    </Grid.Column>
                    <Grid.Column textAlign="left">
                    <Radio
                        toggle
                        checked={maximizeGreenZone}
                        onChange={() => {
                            setMaximizeGreenZone(!maximizeGreenZone)
                        }}
                    />
                    </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
                <Grid.Column textAlign="left" width={3}>
                <label >{t("account.adminConsole.extendSimulationTimeFrame")}</label>
                </Grid.Column>
                <Grid.Column textAlign="left">
                <Radio
                    toggle
                    checked={extendSimTimeFrame}
                    onChange={() => {
                        setExtendSimTimeFrame(!extendSimTimeFrame)
                    }}
                />
                </Grid.Column>
            </Grid.Row>
            <ActiveDaysSelector 
                activeDays={activeDays}
                setActiveDays={setActiveDays}
            />
            <Grid.Row >
                <Grid.Column textAlign="left">
                    <Button
                        positive
                        size="small"
                        disabled={!isAdvancedSettingsModified()}
                        onClick={() => submitAdvancedSettigs()}
                        className="workspace-row-left-button"
                    >
                        {t("save")}
                    </Button>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )

}

AdvancedSettings.propTypes = {
    advancedSettings: PropTypes.object,
    getAdvancedSettings: PropTypes.func,
    updateAdvancedSettings: PropTypes.func,
};

AdvancedSettings.defaultProps = {
    advancedSettings: {},
};

const mapStateToProps = (state) => ({
    advancedSettings: state.adminConsole.advancedSettings,

});
export default connect(mapStateToProps, {
    getAdvancedSettings,
    updateAdvancedSettings,
})(AdvancedSettings);